import { Helpers } from '../../helpers';
import { IForecastParameter } from '../../interfaces/iforecast-parameter';
import { ForecastHorizontal } from '../forecast-horizontal';
import { ForecastParameterDetail } from '../forecast-parameter-detail';
import { Well } from '../well';

export class ForecastParameterBase {
  ForecastParameterId: number;
  CaseId: number | null;
  WellId: number;
  AssetTeamId: number;
  IsActive: boolean;
  EffectiveDate: Date;
  WalkDate: Date;
  ForecastHorizontalId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ForecastParameterDetails_ForecastParemeter?: Array<ForecastParameterDetail> | null;
  ForecastHorizontal?: ForecastHorizontal;
  Well?: Well;

  constructor(item?: IForecastParameter) {
    if (item) {

      this.ForecastParameterId = item.ForecastParameterId;
      this.CaseId = item.CaseId;
      this.WellId = item.WellId;
      this.AssetTeamId = item.AssetTeamId;
      this.IsActive = item.IsActive;
      this.EffectiveDate = item.EffectiveDate ? new Date(item.EffectiveDate) : null;
      this.WalkDate = item.WalkDate ? new Date(item.WalkDate) : null;
      this.ForecastHorizontalId = item.ForecastHorizontalId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ForecastParameterDetails_ForecastParemeter = Helpers.createClassArray(ForecastParameterDetail, item.ForecastParameterDetails_ForecastParemeter);
      this.ForecastHorizontal = new ForecastHorizontal(item.ForecastHorizontal);
      this.Well = new Well(item.Well);
    }
  }
}